import Validator from 'validatorjs'
import {app} from './app'

window.$ = window.jQuery = require('jquery')

require('animate.css')
require('aos/dist/aos.css')
require('materialize-css/js/global')
require('materialize-css/js/pushpin')
require('slick-carousel/slick/slick.css')

require('./styles/main.scss')

window.toastr = require('toastr')
window.toastr.options = {
  'escapeHtml': true,
  'closeButton': false,
  'debug': false,
  'newestOnTop': false,
  'progressBar': true,
  'positionClass': 'toast-top-right',
  'onclick': null,
  'showDuration': '500',
  'hideDuration': '1000',
  'timeOut': '5000',
  'extendedTimeOut': '1000',
  'showEasing': 'swing',
  'hideEasing': 'linear',
  'showMethod': 'fadeIn',
  'hideMethod': 'fadeOut'
}

Validator.useLang('es')

Validator.register('phone', (value) => { return value.match(/^[0-9;\-+ ]+$/) }, 'Ingrese su número correctamente.')
Validator.register('name', (value) => { return value.match(/^[a-zA-ZñáéíóúÑÁÉÍÓÚüÜ;\- ]+$/) }, 'Este campo sólo acepta texto.')

let messages = Validator.getMessages('es')
messages.required = 'Por favor complete este campo!'
messages.email = 'Este no es una dirección de email correcta.'
messages.min = 'Ingrese un valor mayor o igual a :min.'
messages.url = 'Esta no es una url correcta.'
messages.integer = 'Este campo solo acepta números.'
Validator.setMessages('es', messages)

/* eslint-disable */
const aos = require('aos/dist/aos.js')
new aos.init({
  startEvent: 'DOMContentLoaded',
  offset: 50
})


const wow = require('wow.js/dist/wow.js')
new wow({boxClass: 'aos'}).init()
/* eslint-enable */
app.$mount('#root')



// WEBPACK FOOTER //
// ./src/main.js